import React from "react";
import ReactDOM from "react-dom";
import { Button } from "@mui/material";
import Typography from "@mui/material/Typography";
import "../../Assets/Styles/Modal.css";

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  style = { maxWidth: "500px" },
  outsideDisabled = false,
  label,
}) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div
      className="modal-overlay"
      onClick={!outsideDisabled ? onClose : () => {}}
    >
      <div
        className="modal-content text-center space-y-5"
        style={style}
        onClick={(e) => e.stopPropagation()}
      >
        <Typography variant="h6">{label}</Typography>
        <div className="flex space-x-4 justify-center items-center">
          <Button variant="contained" color="primary" onClick={onConfirm}>
            Yes
          </Button>
          <Button variant="outlined" onClick={onClose}>
            No
          </Button>
        </div>
      </div>
    </div>,
    document.getElementById("modal-root") // Ensure modal-root exists in your index.html
  );
};

export default ConfirmModal;
